class TC_PlayerShare {
    constructor (playerInstance) {
        this.player = playerInstance;
    }

    eventShare (e) {
        e.stopPropagation();

        if (this.player.UI.popups.share.hasClass('is-hidden')) {
            this.player.UI.popups.share.removeClass('is-hidden');
            $(document).trigger('playerMakeOpaque');
        } else {
            this.hidePopup();
        }
    }

    initShareEvents () {
        for (let i = 0; i < this.player.UI.buttons.shareItems.length; i++) {
            let item = this.player.UI.buttons.shareItems.eq(i);

            item.on('click', () => {
                if (item.attr('data-value') === 'fb') {
                    this.fbShare();
                    this.hidePopup();
                    return;
                }

                if (item.attr('data-value') === 'twitter') {
                    this.twitterShare();
                    this.hidePopup();
                    return;
                }

                if (item.attr('data-value') === 'email') {
                    this.emailShare();
                    this.hidePopup();
                    return;
                }
            });
        }

        this.emailPopup = {
            overlay: $('.cr-player-email-sharing'),
            form: $('.cr-player-email-sharing-form'),
            btnSend: $('.cr-player-email-sharing').find('.btn-send'),
            btnCancel: $('.cr-player-email-sharing').find('.btn-cancel'),
            trackInfo: $('.cr-player-email-sharing-track-info')
        };

        this.emailPopup.form.on('click', e => {
            e.preventDefault();
            e.stopPropagation();
        });

        this.emailPopup.overlay.on('click', e => {
            this.emailPopup.overlay.addClass('is-hidden');
        });

        this.emailPopup.btnCancel.on('click', e => {
            this.emailPopup.overlay.addClass('is-hidden');
        });

        this.emailPopup.btnSend.on('click', e => {
            e.preventDefault();

            if (this.emailValidateIsCorrect()) {
                this.emailSend();
            }
        });
    }

    fbShare () {
        let url = 'https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2F.calmchristian.com';

        window.open(
            url,
            'fbShareWindow',
            'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
        );
    }

    twitterShare () {
        let url = 'https://twitter.com/intent/tweet?text=%23christiancalmradio&url=https%3A%2F%2F' + window.CSITE.appDomain;

        window.open(
            url,
            'twitterShareWindow',
            'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
        );
    }

    emailShare () {
        this.emailPopup.overlay.removeClass('is-hidden');
        this.emailPopup.trackInfo.find('.cr-player-email-sharing-cover').attr('src', this.player.currentChannel.cover);
        this.emailPopup.trackInfo.find('.cr-player-email-sharing-album-track').text(this.player.currentChannel.album + ' - ' + this.player.currentChannel.title);
        this.emailPopup.trackInfo.find('.cr-player-email-sharing-artist').text(this.player.currentChannel.artist);
        this.emailPopup.form.find('input[name="track-title"]').val(this.player.currentChannel.title);
        this.emailPopup.form.find('input[name="artist-title"]').val(this.player.currentChannel.artist);
        this.emailPopup.form.find('input[name="album-cover"]').val(this.player.currentChannel.cover);
        this.emailPopup.form.find('input[name="album-title"]').val(this.player.currentChannel.album);
        this.emailPopup.form.find('input[name="to"]').val('');
        this.emailPopup.form.find('textarea').val('');
    }

    emailValidateIsCorrect () {
        let inputTo = this.emailPopup.form.find('input[name="to"]');
        let message = this.emailPopup.form.find('textarea');
        let isCorrect = true;

        if (inputTo.val() === '' || inputTo.val().indexOf('@') === -1) {
            inputTo.addClass('has-error');
            inputTo.one('keyup', () => inputTo.removeClass('has-error'));
            isCorrect = false;
        }

        if (message.val() === '') {
            message.addClass('has-error');
            message.one('keyup', () => message.removeClass('has-error'));
            isCorrect = false;
        }

        return isCorrect;
    }

    emailSend () {
        let url = window.CSITE.baseUrlWithLang + '?option=com_calmradio&task=social.sendEmail&format=json';
        this.emailPopup.btnSend.addClass('is-disabled');
        let oldBtnText = this.emailPopup.btnSend.text();
        this.emailPopup.btnSend.text(this.emailPopup.btnSend.attr('data-sending'));
        this.emailPopup.form.find('.error-message').addClass('is-hidden');

        $.post(
            url,
            this.emailPopup.form.serialize()
        ).done((data, status) => {
            if (data.success) {
                this.emailPopup.overlay.addClass('is-hidden');
            } else {
                this.emailPopup.form.find('.error-message').removeClass('is-hidden');
            }

            this.emailPopup.btnSend.text(oldBtnText);
            this.emailPopup.btnSend.removeClass('is-disabled');
        }).fail(() => {
            this.emailPopup.btnSend.text(oldBtnText);
            this.emailPopup.form.find('.error-message').removeClass('is-hidden');
            this.emailPopup.btnSend.removeClass('is-disabled');
        });
    }

    hidePopup () {
        this.player.UI.popups.share.addClass('is-hidden');
    }

    showPopup () {
        this.player.UI.popups.share.removeClass('is-hidden');
    }
}
